module.exports = __webpack_public_path__ + "img/tool.063bd508.svg";